module.exports = __webpack_public_path__ + "img/pes.cd66ab42.jpeg";